<template>
  <section class="similar-product product-slider">
    <h2 class="product-slider__title section-title">
      Аксессуары
    </h2>
    <div :class="['filters-wrapper', {'_with-background': showBackground}]">
      <filtersList
        ref="filtersList"
        class="filters-list"
        @change-filter="changeFilterHandler"
        @show-background="showBackground = true"
        @hide-background="showBackground = false"
      />
    </div>
    <productSlider
      class="product-slider"
      :products-list="activeProductsList"
      :discount="userDiscount"
      @slideChange="changeSlideHandler"
    />
  </section>
</template>

<script>
import productSlider from '@/components/productsSlider/productsSlider';
import filtersList from '@/components/filtersList';
import api from './services/api';

export default {
  name: 'accessories-block',

  components: {
    filtersList,
    productSlider,
  },

  data: () => ({
    elementId: window.accessoriesFilter.elementId,
    currentPage: 1,
    pagesLimit: null,
    productsList: {},
    activeSection: '',
    userDiscount: null,
    activeProductsList: [],
    showBackground: true,
  }),

  computed: {
    currentProductsList() {
      return this.productsList[this.activeSection];
    },
  },

  async mounted() {
    const { data, statusText } = await api.getDiscount();
    if (statusText === 'OK') this.userDiscount = data.data.discount;
  },

  methods: {
    async getAccessoriesItems() {
      const formData = new FormData();

      formData.append('elementId', this.elementId);
      formData.append('sectionValue', this.activeSection);
      formData.append('page', this.currentPage);
      formData.append('limit', 8);

      const { data: { data: response } } = await api.getAccessoriesItems(formData);

      return response;
    },

    async changeFilterHandler(value) {
      this.activeSection = value;
      this.currentPage = 1;

      if (!this.productsList[this.activeSection]) {
        const response = await this.getAccessoriesItems();
        if (response) {
          this.pagesLimit = response.nav.countPage;
          this.productsList[this.activeSection] = response.products;
        }
      }
      this.activeProductsList = this.productsList[this.activeSection];

      this.$nextTick(() => {
        window.setBasketButtons();
      });
    },

    async changeSlideHandler(value) {
      if ((value + 1) % 5 === 0 && this.currentPage < this.pagesLimit) {
        this.currentPage++;

        const { products } = await this.getAccessoriesItems();
        if (products) {
          this.productsList[this.activeSection].push(...products);

          this.activeProductsList = this.productsList[this.activeSection];

          this.$nextTick(() => {
            window.setBasketButtons();
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.filters-wrapper {
  position: relative;
  margin-top: 20px;
  overflow: hidden;

  &._with-background:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(270deg, #FFFFFF 57.07%, rgba(255, 255, 255, 0) 100%);
    width: 50px;
    height: 100%;
  }
}
.filters-list {
  overflow-x: auto;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 0;
    background: #eeeeee;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0;
    background: #b0b0b0;
  }
}

@media (max-width: 1024px) {
  .product-slider {
    margin-top: 20px;
  }
}
</style>
